<template>  
    <div id="sidebar" class="pt-0">
        <div class="cap_leftbar p_right">
          <div class="left_scrollbar">
            <div class="d-flex align-items-center justify-content-between">
            <div class="cap_logo">
                <router-link title="Dashboard" :to="'/dashboard'" class="green"> <img src="../../../../static/fxView/images/logo-white.svg" alt="Logo" /></router-link> 
            </div>
                <div class="closeMenuButton d-xl-none">
                    <a @click.prevent="addRemClass()" href="#"><feather size="27" type="x"></feather> </a>
                </div>
            </div>
           <div class="scrollbar leftBlock">
              <nav class="side-navbar main-menu">
                <ul id="side-main-menu" class="side-menu list-unstyled">
                    <li>
                        <router-link title="Dashboard" :to="'/dashboard'" :class="($route.path == '/dashboard')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="home"></feather> </span> 
                            <span class="inCon-element">Dashboard</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link title="users-list" :to="'/client-details'" :class="($route.path == '/client-details' || $route.path == '/client-details' || $route.path == '/create-ib')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="user-plus"></feather></span> 
                            <span class="inCon-element">Client Details</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link title="users-list" :to="'/trading-accounts'" :class="($route.path == '/trading-accounts')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="user"></feather></span> 
                            <span class="inCon-element">Trading Accounts</span>
                        </router-link>
                    </li> 
                    <li>
                        <router-link title="users-list" :to="'/sub-ib-detail'" :class="($route.path == '/sub-ib-detail' || $route.path == '/sub-ib-detail' || $route.path == '/create-ib')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="file-text"></feather></span> 
                            <span class="inCon-element">Sub-Affiliate Details</span>
                        </router-link>
                    </li> 
                    
                    <li>
                        <router-link title="users-list" :to="'/referal-link'" :class="($route.path == '/referal-link' || $route.path == '/referal')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="link"></feather></span> 
                            <span class="inCon-element">Referral Link Analysis</span>
                        </router-link>
                    </li> 
                    <li>
                        <router-link title="users-list" :to="'/affiliate-earnings'" :class="($route.path == '/affiliate-earnings' || $route.path == '/affiliate')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="sunset"></feather></span> 
                            <span class="inCon-element">Affiliate Earnings</span>
                        </router-link>
                    </li> 
                    <li>
                        <router-link title="withdrawal" :to="'/withdrawal'" :class="($route.path == '/withdrawal')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="credit-card"></feather></span> 
                            <span class="inCon-element">Withdrawal</span>
                        </router-link>
                    </li>   
                    <li>
                        <router-link title="promotional-tools" :to="'/promotional-tools'" :class="($route.path == '/promotional-tools')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="layers"></feather></span> 
                            <span class="inCon-element">Promotional Tools</span>
                        </router-link>
                    </li>
                    
                    <li>
                        <router-link  :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement'}}" :class="($route.path == '/support/requestServiceElement' || $route.path == '/support/openRequest' || $route.path == '/support/closeRequest')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="bgIcon"><feather type="settings"></feather></span> 
                            <span class="inCon-element">Support</span>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link title="users-list" :to="'/listing'" :class="($route.path == '/listing' || $route.path == '/view')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="sprite3 bgIcon"></span> 
                            <span class="inCon-element">Client List</span>
                        </router-link>
                    </li>  -->
                    
                    <!--<li >
                        <router-link title="withdrawal-list" :to="'/withdrawal-list'" :class="($route.path == '/withdrawal-list' || $route.path == '/withdrawal-view')?'tabActive' :''">
                            <span class="sprite4 bgIcon"></span> 
                            <span class="inCon-element">Withdrawal List</span>
                        </router-link>
                    </li> -->
                    <!-- <li>
                        <router-link title="withdrawal" :to="(parseInt(get_user.verified_status ) == 1)?'/withdrawal':'/step1'" :class="($route.path == '/withdrawal')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="sprite4 bgIcon"></span> 
                            <span class="inCon-element">Request Withdrawal</span>
                        </router-link>
                    </li>   
                    <li>
                        <router-link title="withdrawal" :to="'/withdrawal-commission-list'" :class="($route.path == '/withdrawal-commission-list')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="sprite5 bgIcon"></span> 
                            <span class="inCon-element">Withdrawal History</span>
                        </router-link>
                    </li> -->               
                    <!--<li>
                        <router-link title="users-list" :to="'/deposit-list'" :class="($route.path == '/deposit-list' || $route.path == '/deposit-view')?'tabActive' :''">
                            <span class="sprite3 bgIcon"></span> 
                            <span class="inCon-element">Deposit List</span>
                        </router-link>
                    </li> ------->
                    

                    <!-- <li>
                        <router-link title="trading-list" :to="'/trading-list'" :class="($route.path == '/trading-list' || $route.path == '/trading-view')?'tabActive' :''">
                            <span class="shape1"></span>
                            <span class="shape2"></span>
                            <span class="sprite6 bgIcon"></span> 
                            <span class="inCon-element">Trading List</span>
                        </router-link>
                    </li> -->

                    
                </ul>
              </nav>
           </div>
          </div>
      </div>
    </div>
</template>
<script> 
    import { fxViewMixins } from '@/plugins/fxView'
    import { LayoutIcon,UserIcon,UsersIcon,LogOutIcon } from 'vue-feather-icons'
    export default{
        name: 'fxViewApp',
        mixins: [fxViewMixins],    
        data(){
            return {
                knowlegdeBase : false
            }
            
        },
        components: {
           LayoutIcon,
           UsersIcon,
           UserIcon,LogOutIcon
        },
        
        methods:{ 
            addRemClass(){
                if($(document.body).hasClass("openMob-menu")){
                    $(document.body).removeClass("openMob-menu")
                }else{
                    $(document.body).addClass("openMob-menu")
                }
            },
        },
        mounted(){
          $('.dropdown').click( function() {
            $(this).addClass('active').siblings().removeClass('active');
          });
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/fxView/shared/left_navbar.vue